import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from '../FontIcon';
import './CloseIcon.css';

function CloseIcon({ className, title, alt, filled, disabled }) {
  return (
    <FontIcon
      icon="times"
      className={`close-icon ${className || ''}`}
      title={title}
      alt={alt}
      filled={filled}
      disabled={disabled}
    />
  );
}

CloseIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default CloseIcon;
